import React, { useEffect, useRef, useState } from "react";
import {
  addCollege,
  updateCollegeDetails,
} from "../../../Services/HomeService";
import toast from "react-hot-toast";
import 'react-quill/dist/quill.snow.css';
import ReactQuill from "react-quill";
import HttpClientXml from "../../../utils/HttpClientXml";

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const CollegeUniversityPlacementStep2 = ({ data, setData, setCurrentStep, currentStep }) => {

  const initialValues = {
    placementReportText: data?.placementReportText,
    placementAveragePackageText: data?.placementAveragePackageText,
    placementAveragePackageNote: data?.placementAveragePackageNote,
    placementHighestPackageText: data?.placementHighestPackageText,
    placementHighestPackageNote: data?.placementHighestPackageNote,
  }

  const [formData, setFormData] = useState(initialValues);
  const [formDataLoading, setFormDataLoading] = useState(false);

  console.log("KIU32", data?.placementBannerHeading);

  const handleBack = (e) => {
    e?.preventDefault();
    setCurrentStep(currentStep - 1)
  }

  const handleUpdate = async (e) => {
    e?.preventDefault();

    try {
      setFormDataLoading(true);
      const res = await updateCollegeDetails(data?._id, formData);
      console.log("College Add Step2 Message ", res);
      if (res?.status) {
        // toast.success("Data saved successfully");
        setFormData(initialValues)
        setFormDataLoading(false);
        setData({
          ...data,
          placementReportText: formData?.placementReportText,
          placementAveragePackageText: formData?.placementAveragePackageText,
          placementAveragePackageNote: formData?.placementAveragePackageNote,
          placementHighestPackageText: formData?.placementHighestPackageText,
          placementHighestPackageNote: formData?.placementHighestPackageNote,
        })
        setCurrentStep(currentStep + 1)
      } else {
        toast.error(res?.message);
        setFormDataLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add College.");
      console.error("Error adding College:", error);
      setFormDataLoading(false);
    }
  };

  useEffect(() => {
    setFormData(initialValues)
  }, [data])

  return (
    <>

      <section className="chartBox_area">
        <form
          onSubmit={(e) => {
            handleUpdate(e);
          }}
        >
          <div className="row d-flex justify-content-center">

            <div className="col-md-12 mt-3">
              <label htmlFor="name">
                Report Information
              </label>
              <ReactQuill
                modules={modules}
                theme="snow"
                value={formData?.placementReportText}
                onChange={(value) => {
                  setFormData((prev) => ({
                    ...prev,
                    placementReportText: value,
                  }));
                }}
                placeholder="Enter Report Information"
                style={{
                  height: "150px",
                  marginBottom: "40px",
                  fontFamily: "Poppins",
                  fontSize: "1rem"
                }}
              />
            </div>

            <div className="col-md-12 mt-3">
              <label htmlFor="name">
                Average Package Information
              </label>
              <ReactQuill
                modules={modules}
                theme="snow"
                value={formData?.placementAveragePackageText}
                onChange={(value) => {
                  setFormData((prev) => ({
                    ...prev,
                    placementAveragePackageText: value,
                  }));
                }}
                placeholder="Enter Average Package Information"
                style={{
                  height: "150px",
                  marginBottom: "40px",
                  fontFamily: "Poppins",
                  fontSize: "1rem"
                }}
              />
            </div>

            <div className="col-md-12 mt-3">
              <label htmlFor="name">
                Average Package Note
              </label>
              <ReactQuill
                modules={modules}
                theme="snow"
                value={formData?. placementAveragePackageNote}
                onChange={(value) => {
                  setFormData((prev) => ({
                    ...prev,
                     placementAveragePackageNote: value,
                  }));
                }}
                placeholder="Enter Average Package Note"
                style={{
                  height: "150px",
                  marginBottom: "40px",
                  fontFamily: "Poppins",
                  fontSize: "1rem"
                }}
              />
            </div>

            <div className="col-md-12 mt-3">
              <label htmlFor="longDescription">
                Highest Package Information
              </label>
              <ReactQuill
                modules={modules}
                theme="snow"
                value={formData?.placementHighestPackageText}
                onChange={(value) => {
                  setFormData((prev) => ({
                    ...prev,
                    placementHighestPackageText: value,
                  }));
                }}
                placeholder="Enter Highest Package Information"
                style={{
                  height: "150px",
                  marginBottom: "40px",
                  fontFamily: "Poppins",
                  fontSize: "1rem"
                }}
              />
            </div>
            <div className="col-md-12 mt-3">
              <label htmlFor="longDescription">
                Highest Package Note
              </label>
              <ReactQuill
                modules={modules}
                theme="snow"
                value={formData?.placementHighestPackageNote}
                onChange={(value) => {
                  setFormData((prev) => ({
                    ...prev,
                    placementHighestPackageNote: value,
                  }));
                }}
                placeholder="Enter Highest Package Note"
                style={{
                  height: "150px",
                  marginBottom: "40px",
                  fontFamily: "Poppins",
                  fontSize: "1rem"
                }}
              />
            </div>

          </div>
          <div className=" d-flex justify-content-end">
            {
              currentStep > 1 &&
              <button
                type="button"
                className="btn mt-3"
                style={{
                  background: "rgb(133, 218, 79)",
                  borderRadius: "13px",
                  marginRight: "15px"
                }}
                onClick={(e) => handleBack(e)}
              >Back
              </button>
            }

            <button
              disabled={formDataLoading}
              type="submit"
              className="btn mt-3"
              style={{
                background: "rgb(133, 218, 79)",
                borderRadius: "13px",
              }}
            >
              {formDataLoading
                ? "Saving..."
                // : "Add College/University"
                : `Save & Continue`
              }
            </button>
          </div>
        </form>
      </section>

    </>
  );
};

export default CollegeUniversityPlacementStep2;
